import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const warehouseInstructionsTemplatesAdapter = getAdapter();

const warehouseInstructionsTemplatesSlice = createSlice({
  name: 'warehouseInstructionsTemplates',
  initialState: warehouseInstructionsTemplatesAdapter.getInitialState(),
  reducers: {
    setWarehouseInstructionsTemplates: (state, { payload: { warehouseInstructionsTemplates } }) => {
      warehouseInstructionsTemplatesAdapter.setAll(state, warehouseInstructionsTemplates);
    },
  },
});

const selectors = warehouseInstructionsTemplatesAdapter.getSelectors(({ warehouseInstructionsTemplates }) => warehouseInstructionsTemplates);

export const getWarehouseInstructionsTemplates = (state) => selectors.selectAll(state);

export const {
  setWarehouseInstructionsTemplates,
} = warehouseInstructionsTemplatesSlice.actions;

export default warehouseInstructionsTemplatesSlice.reducer;